
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.868 11.158a.32.32 0 00.187.578h3.856l.059.192.06.195a.868.868 0 00.83.613h2.528l4.234-3.148a.527.527 0 01.064-.067l1.16-.984h-2.218v-.195h2.447l.354-.301h-3.856v-.195h4.08v.004l.028-.023 1.98 3.74a.32.32 0 00.565-.3l-1.97-3.718.216-.004 2.301-.037a.19.19 0 00.186-.17l.04-.36a.195.195 0 00-.017-.104l-1.268-2.615-2.517-2.69a.135.135 0 00-.154-.03l-.36.159a.136.136 0 00-.065.188l1.03 1.93-.789.684-.149.13-.548-1.036a.32.32 0 00-.197-.158l-1.04-.291a.32.32 0 00-.173.615l.909.254.43.81h-1.415l-2.542-.664a.623.623 0 00-.543.113L9.57 5.866a1.23 1.23 0 01-.722.263l-2.198.07a.78.78 0 01-.651-.313c-.1-.135-.223-.291-.343-.442a1.607 1.607 0 00-1.285-.606l-2.603.048a.146.146 0 00-.143.139l-.021.42a.147.147 0 00.074.134l5.25 2.958.042.139.06.194-3.162 2.287.001.001zm15.499-6.64l1.09 2.276s-1.07-.573-1.39-1.243c-.318-.67.3-1.033.3-1.033zm-14.325 6.58l2.186-1.582.06.193.367 1.197.06.191H5.041zm-2.904.319a1.92 1.92 0 001.917 1.917 1.92 1.92 0 001.848-1.406h1.164a3.055 3.055 0 11-.871-2.691l-.944.683a1.909 1.909 0 00-1.197-.42 1.92 1.92 0 00-1.917 1.917zM19.944 9.5a1.92 1.92 0 011.917 1.917 1.92 1.92 0 01-1.917 1.917 1.92 1.92 0 01-1.917-1.917c0-.548.231-1.042.601-1.392l-.545-1.03a3.055 3.055 0 10.904-.48l.545 1.03c.133-.03.27-.045.412-.045zM5.852 10.748c.019.052.036.104.05.158h1.165a3.033 3.033 0 00-.271-.84l-.944.682zm8.163 1.942a.171.171 0 01-.116.046h-1.974l3.584-2.666-.069 1.194a.21.21 0 01-.065.14l-1.36 1.286z","fill":"currentColor"}})])
          )
        }
      }
    